import * as SmsNotifications from './SmsNotifications.css';
import * as SmsPopup from './components/SmsPopup.css';
export default {
    SmsNotifications,
    SmsPopup
};
